import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

export const AssetTypeEnum = z.enum(['Image', 'Uploaded Video', 'External Video'])
export type AssetType = z.infer<typeof AssetTypeEnum>

export const AssetItemSchema = buildEntrySchemaFor('assetItem', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      heading: RichTextSchema,
      description: RichTextSchema,
      assetType: AssetTypeEnum,
      optionImage: safeOptional(AssetSchema),
      optionVideo: safeOptional(AssetSchema),
      optionPoster: safeOptional(AssetSchema),
      autoplay: safeOptional(z.boolean()),
      videoSource: safeOptional(z.string()),
    }),
  ),
})
export type AssetItem = z.infer<typeof AssetItemSchema>
